import {
  GET_CLIENT_CHECKINS,
  GET_CLIENT_CHECKINS_SUCCESS,
  GET_CLIENT_CHECKINS_ERROR,
  COMMENT_CHECKIN,
  COMMENT_CHECKIN_SUCCESS,
  COMMENT_CHECKIN_ERROR,
  MARK_CHECKIN_REVIEWED,
  MARK_CHECKIN_REVIEWED_SUCCESS,
  MARK_CHECKIN_REVIEWED_ERROR,
  GET_CURRENT_CHECKIN,
  GET_CURRENT_CHECKIN_SUCCESS,
  GET_CURRENT_CHECKIN_ERROR,
  SUBMIT_CHECKIN,
  SUBMIT_CHECKIN_SUCCESS,
  SUBMIT_CHECKIN_ERROR,
  RESET_SUBMIT_CHECKIN,
  GET_MY_CHECKINS,
  GET_MY_CHECKINS_SUCCESS,
  GET_MY_CHECKINS_ERROR,
} from './constants';

const initialState = {
  list: [],
  loading: false,
  err: null,
  commenting: false,
  commentErr: null,
  markingReviewed: false,
  // Client-side submit state
  current: null,
  currentLoading: false,
  currentErr: null,
  submitting: false,
  submitResult: null,
  submitErr: null,
  // Client-self history (web parity with mobile /check-ins).
  myList: [],
  myLoading: false,
  myErr: null,
};

export default function checkIn(state = initialState, action) {
  switch (action.type) {
    case GET_CLIENT_CHECKINS:
      return { ...state, loading: true, err: null };
    case GET_CLIENT_CHECKINS_SUCCESS:
      return {
        ...state,
        list: Array.isArray(action.payload) ? action.payload : [],
        loading: false,
        err: null,
      };
    case GET_CLIENT_CHECKINS_ERROR:
      return { ...state, loading: false, err: action.err };

    case COMMENT_CHECKIN:
      return { ...state, commenting: true, commentErr: null };
    case COMMENT_CHECKIN_SUCCESS: {
      const updated = action.payload;
      if (!updated?._id) {
        return { ...state, commenting: false };
      }
      return {
        ...state,
        commenting: false,
        list: state.list.map((c) =>
          String(c._id) === String(updated._id) ? updated : c
        ),
      };
    }
    case COMMENT_CHECKIN_ERROR:
      return { ...state, commenting: false, commentErr: action.err };

    case MARK_CHECKIN_REVIEWED:
      return { ...state, markingReviewed: true, commentErr: null };
    case MARK_CHECKIN_REVIEWED_SUCCESS: {
      const updated = action.payload;
      if (!updated?._id) {
        return { ...state, markingReviewed: false };
      }
      return {
        ...state,
        markingReviewed: false,
        list: state.list.map((c) =>
          String(c._id) === String(updated._id) ? updated : c
        ),
      };
    }
    case MARK_CHECKIN_REVIEWED_ERROR:
      return { ...state, markingReviewed: false, commentErr: action.err };

    case GET_CURRENT_CHECKIN:
      return { ...state, currentLoading: true, currentErr: null };
    case GET_CURRENT_CHECKIN_SUCCESS:
      return {
        ...state,
        current: action.payload || null,
        currentLoading: false,
        currentErr: null,
      };
    case GET_CURRENT_CHECKIN_ERROR:
      return { ...state, currentLoading: false, currentErr: action.err };

    case SUBMIT_CHECKIN:
      return { ...state, submitting: true, submitErr: null, submitResult: null };
    case SUBMIT_CHECKIN_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitResult: action.payload,
        // Mirror into `current` so the home banner flips immediately.
        current: action.payload,
      };
    case SUBMIT_CHECKIN_ERROR:
      return { ...state, submitting: false, submitErr: action.err };
    case RESET_SUBMIT_CHECKIN:
      return { ...state, submitting: false, submitErr: null, submitResult: null };

    case GET_MY_CHECKINS:
      return { ...state, myLoading: true, myErr: null };
    case GET_MY_CHECKINS_SUCCESS:
      return {
        ...state,
        myList: Array.isArray(action.payload) ? action.payload : [],
        myLoading: false,
        myErr: null,
      };
    case GET_MY_CHECKINS_ERROR:
      return { ...state, myLoading: false, myErr: action.err };

    default:
      return state;
  }
}
